/**
 * Tax labels for selects/lists. Nil-rated uses the server name (default "GST 0%") so it matches
 * the Taxes page and printed names.
 */

export function getTaxDropdownLabel(tax) {
  if (!tax) return '';
  if (tax.supplyType === 'NIL_RATED') {
    return tax.name != null && String(tax.name).trim() !== ''
      ? String(tax.name)
      : 'GST 0%';
  }
  return tax.name != null ? String(tax.name) : '';
}

/**
 * Same as {@link getTaxDropdownLabel}, with rate suffix when useful (e.g. quick entry grids).
 * Nil-rated → server name only (no duplicate "(0%)" suffix).
 */
export function getTaxDropdownLabelWithRate(tax) {
  if (!tax) return '';
  if (tax.supplyType === 'NIL_RATED') {
    return tax.name != null && String(tax.name).trim() !== ''
      ? String(tax.name)
      : 'GST 0%';
  }
  const r = tax.rate != null ? tax.rate : 0;
  const base = tax.name != null ? String(tax.name) : '';
  return `${base} (${r}%)`;
}
